const PREPAYMENT = "1";
const PAY_ON_DAY = "2";
const isEnabled = (value) => value === true || Number(value) === 1;

export const isLunaOfficialEvent = (event) => Number(event.owner_status) === 1;

export const isPrepaymentOnlyEvent = (event) => (
    isLunaOfficialEvent(event) && isEnabled(event.is_prepayment_only)
);

export const isPrepaymentRegistrationClosed = (event) => {
    if (isPrepaymentOnlyEvent(event)) {
        return isEnabled(event.is_prepayment_only_registration_closed);
    }

    return isEnabled(event.is_deadline);
};

const formatAmount = (amount) => amount === null
    ? " - "
    : amount.toLocaleString();

export const buildPaymentOptions = (event, prepaymentAmount = null, payOnDayAmount = null) => {
    const options = [];
    const isPrepaymentOnly = isPrepaymentOnlyEvent(event);

    if (isLunaOfficialEvent(event) && !isPrepaymentRegistrationClosed(event)) {
        options.push({
            value: PREPAYMENT,
            label: `事前決済（Web決済:${formatAmount(prepaymentAmount)}円）`,
            amount: prepaymentAmount === null ? 0 : prepaymentAmount,
        });
    }

    if (isPrepaymentOnly) {
        options.push({
            value: PAY_ON_DAY,
            label: "当日決済（利用できません）",
            amount: 0,
            disabled: true,
        });
    } else {
        options.push({
            value: PAY_ON_DAY,
            label: `当日決済（現金のみ:${formatAmount(payOnDayAmount)}円）`,
            amount: payOnDayAmount === null ? 0 : payOnDayAmount,
            disabled: false,
        });
    }

    return options;
};

export const isPaymentOptionSelectable = (option) => !option.disabled;
